export interface PaginationHeader {
  TotalCount: number;
  PageSize: number;
  CurrentPage: number;
  HasNext: boolean;
  HasPrevious: boolean;
}

export const PAGINATION_HEADER_NAME = 'x-pagination' as const;
